import type { Claim } from '../api/claims';

/**
 * A claim already sent to its lender in a bulk submission must never be
 * offered Send LOC / Send new LOC / Resend LOC: the lender already has it.
 *
 * Same rule as the backend (python-backend/app/services/bulk_submission.py)
 * and the cancellation fee, which counts submissionSent OR submissionSentDate
 * as "LOC sent via bulk submission".
 */
export const isBulkSubmitted = (
  claim: Partial<Pick<Claim, 'submissionSent' | 'submissionSentDate'>>,
): boolean => Boolean(claim.submissionSent || claim.submissionSentDate);

type FirstLocClaim = Partial<
  Pick<Claim, 'locSentDate' | 'status' | 'isLegacyClaim' | 'submissionSent' | 'submissionSentDate'>
>;

/** Whether the per-claim "Send LOC" and "Send LOC to All" buttons may offer this claim. */
export const canSendFirstLoc = (claim: FirstLocClaim): boolean =>
  !claim.locSentDate
  && claim.status !== 'CANCELLED'
  && !claim.isLegacyClaim
  && !isBulkSubmitted(claim);
